// lib
import railsPostFetch from '@aytm/lib/common/rails-post-fetch'
import { call, delay } from 'redux-saga/effects'

// stores
import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

export default function* createShareKeySaga(payload) {
  const createSharedKeyURL = staticStore.urls.createSharedKey
  if (!createSharedKeyURL) {
    throw new Error('No "createSharedKey" endpoint URL')
  }
  for (let i = 0; i < 5; i++) {
    try {
      const response = yield call(railsPostFetch, createSharedKeyURL, {
        body: JSON.stringify({
          dashboard_id: staticStore.dashboardID,
          ...payload
        })
      })
      if (!response.ok) {
        throw new Error(response.error || 'Error creating shared key')
      }
      const body = yield call([response, 'json'])
      return body
    } catch (error) {
      if (i < 4) {
        yield delay(1500)
      } else {
        throw error
      }
    }
  }
  throw new Error('Error creating shared key after multiple attempts')
}
